(function () {
  'use strict';
  window.__bootDiag = [];
  var start = performance.now();
  function sample(tag) {
    var root = document.querySelector('[data-screen-label="Storefront"]');
    if (!root) return;
    var kids = root.children;
    var rows = [];
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      var cs = getComputedStyle(el);
      var r = el.getBoundingClientRect();
      rows.push({
        i: i,
        tag: el.tagName,
        id: el.id || null,
        cls: (el.className || '').toString().slice(0,30),
        txt: (el.textContent || '').trim().slice(0,40),
        display: cs.display,
        top: Math.round(r.top),
        height: Math.round(r.height)
      });
    }
    window.__bootDiag.push({ t: Math.round(performance.now() - start), tag: tag, rows: rows });
  }
  var origRenderVals = window.SATComponent && window.SATComponent.prototype.renderVals;
  if (origRenderVals) {
    window.SATComponent.prototype.renderVals = function () {
      var out = origRenderVals.apply(this, arguments);
      var self = this;
      setTimeout(function () { sample('post-render page=' + (self && self.state && self.state.page)); }, 0);
      return out;
    };
  }
  for (var d = 0; d <= 2000; d += 25) {
    setTimeout((function (dd) { return function () { sample('t+' + dd); }; })(d), d);
  }
})();
